// QuestionPalette.jsx

import { useState } from "react";
import QuestionCard from "./QuestionCard";

export default function QuestionPalette({ questions, onAnswer,onToggleReview }) {
  const [openSections, setOpenSections] = useState({});

  // group by pool
  const grouped = questions.reduce((acc, q) => {
    if (!acc[q.poolId]) {
      acc[q.poolId] = {
        poolText: q.poolText,
        questions: [],
      };
    }
    acc[q.poolId].questions.push(q);
    return acc;
  }, {});

  const toggleSection = (poolId) => {
    setOpenSections((prev) => ({
      ...prev,
      [poolId]: !prev[poolId],
    }));
  };

  return (
    <div>
      {Object.entries(grouped).map(([poolId, section]) => {

        const reviewCount = section.questions.filter(q => q.markForReview).length;
        return(
        <div key={poolId} style={styles.section}>
          {/* Section Header */}
          <div
            style={styles.sectionHeader}
            onClick={() => toggleSection(poolId)}
          >
            {section.poolText}
                            {reviewCount > 0 && (
                  <span style={styles.reviewBadge}> ({reviewCount})</span>
                )}
            <span>{openSections[poolId] ? "▲" : "▼"}</span>
          </div>

          {/* Section Body */}
          {openSections[poolId] && (
            <div style={styles.sectionBody}>
              {section.questions.map((q) => (
                <QuestionCard
                    key={q.id}
                    question={q}
                    selected={q.response}   // ✅ read from question.answer
                    onAnswer={onAnswer}
                    onToggleReview={onToggleReview}
                />
              ))}
            </div>
          )}
        </div>
      )})}
    </div>
  );
}

const styles = {
    section: {
    border: "1px solid #ddd",
    borderRadius: 6,
    marginBottom: 12,
    background: "#fff",
},
  sectionHeader: {
    padding: 12,
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    background: "#f5f5f5",
  },
  sectionBody: {
    padding: 12,
  },
    reviewBadge: {
    color: "#ff9800",
    fontWeight: "bold",
    marginLeft: 6,
  },
};
    // import QuestionCard from "./QuestionCard";
    
    // export default function QuestionPalette({ questions, answers, onAnswer }) {
    //     return (
    //         <div>
    //             {/* <h3>Questions</h3> */}
    
    //             {questions.map((q) => (
    //                 <QuestionCard
    //                     key={q.id}
    //                     question={q}
    //                     selected={q.response}   // ✅ read from question.answer
    //                     onAnswer={onAnswer}
    //                 />
    //             ))}
    //         </div>
    //     );
    // }